import { render, staticRenderFns } from "./GroupPhotoalbumPage.vue?vue&type=template&id=f3de4f7c&scoped=true&"
import script from "./GroupPhotoalbumPage.vue?vue&type=script&lang=js&"
export * from "./GroupPhotoalbumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3de4f7c",
  null
  
)

export default component.exports